(() => {
  function init(root = document) {
    root.querySelectorAll('[data-nv-one]').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = 'true';
      // gallery
      const slides = Array.from(sec.querySelectorAll('[data-nv-slide]'));
      const thumbs = Array.from(sec.querySelectorAll('[data-nv-thumb]'));
      thumbs.forEach(t => t.addEventListener('click', () => {
        const i = t.dataset.nvThumb;
        slides.forEach(s => s.classList.toggle('is-active', s.dataset.nvSlide === i));
        thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      }));
      // quantity
      const qty = sec.querySelector('#nv-one-qty');
      sec.querySelectorAll('[data-nv-qty]').forEach(b => b.addEventListener('click', () => {
        const n = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.nvQty, 10)));
        qty.value = n;
      }));
      // variant price
      const sel = sec.querySelector('[data-nv-variant]');
      const price = sec.querySelector('[data-nv-price]');
      const compare = sec.querySelector('[data-nv-compare]');
      const sticky = sec.querySelector('[data-nv-sticky-price]');
      if (sel) sel.addEventListener('change', () => {
        const o = sel.selectedOptions[0];
        price.textContent = o.dataset.price;
        if (sticky) sticky.textContent = o.dataset.price;
        if (o.dataset.compare) { compare.textContent = o.dataset.compare; compare.hidden = false; } else { compare.hidden = true; }
      });
      // sticky bar: show once buy box has scrolled out of view (mobile)
      const bar = sec.querySelector('[data-nv-sticky]');
      const target = sec.querySelector('.nv-one-add');
      if (bar && target && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([e]) => {
          const gone = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', gone);
          bar.setAttribute('aria-hidden', String(!gone));
          const cta = bar.querySelector('[data-nv-sticky-cta]');
          if (cta) cta.tabIndex = gone ? 0 : -1;
        });
        io.observe(target);
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
